import { render, staticRenderFns } from "./spanish_resources.vue?vue&type=template&id=24e32de2&scoped=true"
import script from "./spanish_resources.vue?vue&type=script&lang=js"
export * from "./spanish_resources.vue?vue&type=script&lang=js"
import style0 from "./spanish_resources.vue?vue&type=style&index=0&id=24e32de2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e32de2",
  null
  
)

export default component.exports